import { ReductionRead } from '@miles/domain/Store/Models/Reduction/ReductionRead'
import { calculateTotalReduction } from 'components/Checkout/RaceProductCard/reductionFormat'
import { RaceId } from 'domain/models/ValueObject/EntityIds'
import { NonEmptyArray } from 'helpers/array'
import { LiveEventRace } from 'services/api/database/EventService'

export const FrontReductionService = {
  reducePriceDependingOnRace: (
    reductionFiltered: NonEmptyArray<ReductionRead>,
    race: LiveEventRace
  ) => {
    const raceSegmentsLength = race.raceSegments.length || 1

    const reductionsToApply = reductionFiltered
      .filter(FrontReductionService.isValidReductionsForRace(race.id))
      .map((reduction) =>
        reduction.amountType === 'PERCENT' &&
        race.paymentCollectionType !== 'MULTIPLE'
          ? {
              ...reduction,
              amount:
                reduction.amount /
                (raceSegmentsLength * (race.minTeamSize ?? 1))
            }
          : reduction
      )

    if (
      FrontReductionService.raceIsEligibleForReduction(
        race.id,
        reductionFiltered
      )
    ) {
      if (race.priceType === 'PER_TEAM') {
        const duplicatedReductionsDependsRaceSegment = Array.from(
          {
            length: raceSegmentsLength * (race.minTeamSize ?? 1)
          },
          () => reductionsToApply
        ).flat()

        return FrontReductionService.applyReductionDependingOnRace(
          race.priceWithReduction ?? race.price ?? 0,
          duplicatedReductionsDependsRaceSegment
        )
      } else {
        return race.paymentCollectionType === 'MULTIPLE'
          ? FrontReductionService.applyReductionDependingOnRace(
              race.priceWithReduction ?? race.price ?? 0,
              reductionsToApply
            )
          : FrontReductionService.applyReductionDependingOnRace(
              race.priceWithReduction ?? race.price ?? 0,
              reductionFiltered.filter(
                FrontReductionService.isValidReductionsForRace(race.id)
              )
            )
      }
    }
    return race.priceWithReduction ?? race.price
  },
  raceIsEligibleForReduction: (
    raceId: RaceId,
    reductions: NonEmptyArray<ReductionRead>
  ): boolean =>
    reductions.some(({ races }) => races.some(({ id }) => id === raceId)),
  isValidReductionsForRace:
    (raceId: RaceId) =>
    ({ races, validFrom, validUntil }: ReductionRead) =>
      races.some(({ id }) => id === raceId) &&
      (validFrom ? validFrom <= new Date() : true) &&
      (validUntil ? validUntil >= new Date() : true),
  applyReductionDependingOnRace: (
    price: number,
    reductions: ReductionRead[]
  ): number => Math.max(price - calculateTotalReduction(price, reductions), 0)
}
